/*
 * @Author: cc
 * @Date: 2020-09-01 10:11:21
 * @LastEditTime: 2021-04-23 17:43:43
 * @LastEditors: cc
 * @FilePath: \xjmediacloud\app\editingCenter\iWo\iWoPreview\directive\trsChangeFontSize.js
 * @Description: 
 */
'use strict';

angular.module('trsChangeListStyleModule', [])
    .directive('trsChangeListStyle', ['$sessionStorage', '$timeout', function ($sessionStorage, $timeout) {
        return {
            restrict: 'A',
            link: function () { 
                $timeout(function() {
                    getFontSize();
                });

                /**
                 * [getFontSize description] 获取字体大小
                 * @return  {[type]}  [return description]
                 */
                function getFontSize() {
                    let articleTitle = $('.style-change-for-title');
                    var listTitleFontSize = $sessionStorage.get('curUserInfo') ? $sessionStorage.get('curUserInfo').FONTSIZE : '18';
                    articleTitle.css({
                        'fontSize': listTitleFontSize + 'px'
                    });
                }


            }
        };
    }]);
